import { motion, useInView } from 'framer-motion';
import { Volume2, VolumeX } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';

const HowItWorks = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, amount: 0.5 });
  const [isMuted, setIsMuted] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const containerVariants = {
    hidden: {
      width: isMobile ? '95%' : '80%',
      height: isMobile ? '250px' : '85vh',
      borderRadius: '1.5rem',
    },
    visible: {
      width: '100%',
      height: isMobile ? '300px' : '100vh',
      borderRadius: '0rem',
    },
  };

  // Sample video URL - replace with your desired video
  const videoUrl = 'https://www.youtube.com/watch?v=sJGVcb5fn2c';

  return (
    <section
      id='works'
      className='flex flex-col h-[55vh] max-w-4/5 lg:max-w-full items-center justify-center bg-legal-bg-brown md:h-[calc(100vh+12rem)] '
    >
      <div className='pt-20 pb-8 md:pb-10 '>
        <h2 className='font-marcellus flex-col flex gap-1 md:gap-4 md:flex-row items-center text-center text-3xl md:text-5xl lg:text-6xl font-semibold text-legal-dark-blue capitalize'>
          <span>Legal Expertise</span>
          <span className='font-playfair font-bold text-legal-brown italic border-b-4 border-legal-brown'>
            Anywhere, Anytime
          </span>
        </h2>
      </div>

      <motion.div
        ref={ref}
        className='relative mx-auto bg-legal-black p-2'
        variants={containerVariants}
        initial='hidden'
        animate={isInView ? 'visible' : 'hidden'}
        transition={{ duration: 1, ease: 'easeInOut' }}
      >
        <ReactPlayer
          url={videoUrl}
          playing={isInView}
          loop
          muted={isMuted}
          width='100%'
          height='100%'
          config={{
            youtube: {
              playerVars: { showinfo: 1 },
            },
          }}
        />

        {/* Mute/Unmute Button */}
        <button
          onClick={() => setIsMuted(!isMuted)}
          className='absolute bottom-4 right-4 rounded-full bg-black/50 p-2 text-white transition-colors hover:bg-black/70'
        >
          {isMuted ? (
            <VolumeX className='h-6 w-6' />
          ) : (
            <Volume2 className='h-6 w-6' />
          )}
        </button>
      </motion.div>
    </section>
  );
};

export default HowItWorks;
